module.exports = __webpack_public_path__ + "static/media/horrormax-banner-world-w4r.0b34ca5b.jpg";